import React from 'react'
import PropTypes from 'prop-types'
import './ProjectWizard.scss'

/**
 * WizardProgress Component
 *
 * Displays the step progress indicator for the project wizard
 */
const WizardProgress = ({ currentStep, steps, onStepClick }) => {
	return (
		<div className="wizard-progress">
			<div className="wizard-progress__track">
				{steps.map((step, index) => {
					const stepNumber = index + 1
					const isActive = stepNumber === currentStep
					const isCompleted = stepNumber < currentStep
					const isClickable = stepNumber < currentStep

					return (
						<React.Fragment key={step.id}>
							{/* Connector line (not for first step) */}
							{index > 0 && (
								<div
									className={`wizard-progress__connector ${
										stepNumber <= currentStep ? 'wizard-progress__connector--active' : ''
									}`}
								/>
							)}

							{/* Step indicator */}
							<div
								className={`wizard-progress__step ${
									isActive ? 'wizard-progress__step--active' : ''
								} ${isCompleted ? 'wizard-progress__step--completed' : ''} ${
									isClickable ? 'wizard-progress__step--clickable' : ''
								}`}
								onClick={() => isClickable && onStepClick && onStepClick(stepNumber)}
								role={isClickable ? 'button' : undefined}
								tabIndex={isClickable ? 0 : undefined}
								onKeyDown={(e) => {
									if (isClickable && (e.key === 'Enter' || e.key === ' ')) {
										onStepClick && onStepClick(stepNumber)
									}
								}}
							>
								<div className="wizard-progress__number">
									{isCompleted ? (
										<i className="icon-check" />
									) : (
										stepNumber
									)}
								</div>
								<div className="wizard-progress__label">
									<span className="wizard-progress__title">{step.title}</span>
									{step.subtitle && (
										<span className="wizard-progress__subtitle">{step.subtitle}</span>
									)}
								</div>
							</div>
						</React.Fragment>
					)
				})}
			</div>
		</div>
	)
}

WizardProgress.propTypes = {
	currentStep: PropTypes.number.isRequired,
	steps: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			title: PropTypes.string.isRequired,
			subtitle: PropTypes.string,
		})
	).isRequired,
	onStepClick: PropTypes.func,
}

export default WizardProgress
